import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../lib/api-client";
import { queryKeys } from "../query-keys";
import { DashboardResponseSchema } from "@applicant-reviewer/api";

export function useDashboard() {
  return useQuery({
    queryKey: queryKeys.dashboard.data(),
    queryFn: () => apiClient.get("/dashboard", DashboardResponseSchema),
  });
}
